import React, { FC } from 'react';
import { CommentaryListHybridCommentary } from '../../../commentary/list/CommentaryListHybridCommentary';
import { CommentaryListOpenCommentary } from '../../../commentary/list/CommentaryListOpenCommentary';
import { CommentaryListPaperCommentary } from '../../../commentary/list/CommentaryListPaperCommentary';

import { trackLawyerCommentary } from './lawyerCommentaryUtils';
import { Commentary, TypeLabel } from '../../../commentary/commentary.types';

type Props = {
  commentary: Commentary;
  index: number;
};

export const LawyerCommentarySelection: FC<Props> = ({ commentary, index }) => {
  const source = 'lawyer_comments';

  if (commentary.typeLabel === TypeLabel.PAPER) {
    return <CommentaryListPaperCommentary commentary={commentary} />;
  }

  const trackLawyer = () => {
    const { url } = commentary;
    trackLawyerCommentary({
      url,
      index,
      isAccessLimited: true,
    });
  };

  if (commentary.typeLabel === TypeLabel.HYBRID) {
    return (
      <CommentaryListHybridCommentary
        source={source}
        commentary={commentary}
        onCommentaryClicked={trackLawyer}
      />
    );
  }

  return (
    <CommentaryListOpenCommentary
      source={source}
      commentary={commentary}
      onCommentaryClicked={trackLawyer}
    />
  );
};
